import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';
import ItemCard from 'styled/ItemCard/Card';

const DeleteButton = styled(SimpleButton)`
  position: absolute;
  top: -2px;
  right: 0;
  display: none;
  color: #fff;
  opacity: 0.6;
  transition: opacity 0.15s ease-out;

  &:hover {
    opacity: 1;
  }

  /* stylelint-disable */
  ${ItemCard}:hover & {
    display: block;
  }
  /* stylelint-enable */
`;

export default DeleteButton;
